export default {
    LOAD_EMAIL_NOTIFICATION(state, email_notification) {
        state.items = email_notification;
    }
}